import React, { useEffect } from 'react';
import { Cards, Clock, Copy, Eye, Wallet3 } from 'iconsax-react';
import FundwalletModal from '../../Components/Wallet/FundwalletModal';
// import WithdrawalModal from '../../Components/Wallet/WithdrawalModal';
import { useWallet } from '../../Services/hooks/wallet';
import { useSelector } from 'react-redux';
import { RootState } from '../../Storeredux/reducers/rootReducer';
import { User, userData } from '../../Storeredux/constants/actionTypes';
import { WalletLoader } from '../../Components/Loader/walletLoader';
import { formatCurrency } from '../../Utils/currencyFormat';
import { dateFormat } from '../../Utils/dateFormat';
import Loader from '../../Components/Loader/Loader';
// import { TopUpIcon } from '../../Assets/Icons/topUp';
// import { GenerateAdd } from '../../Assets/Icons/generateAdd';

function Wallet() {
  const UserState = useSelector((state: RootState) => state.user as userData);
  const { user } = UserState;
  const [isOpen, setIsOpen] = React.useState({
    fundwallet: false,
    withdrawal: false,
  });

  const { getWalletData, loading, walletInfo, transactionHistory } = useWallet();

  const handleRequest = async () => {
    const response = await getWalletData(user.company_id);
    console.log(response);
    // setData(response.results);
    // setHistory(response.history);
  };

  function extractBankName(accountString: string) {
    if (!accountString) {
      return 'nill';
    }
    const match = accountString.split('(');
    return match ? match[1] : 'nill';
  }

  function extractAccountNumber(accountString: string) {
    console.log(accountString);
    if (!accountString) {
      return 'nill';
    }
    const match = accountString.split('(');
    console.log(accountString, match);

    return match ? match[0] : 'nill';
  }

  useEffect(() => {
    handleRequest();
  }, []);
  return (
    <div className='py-10'>
      <div className='rounded-3xl mx-auto '>
        <div className='flex flex-col md:flex-row py-5 px-5'>
          <div className='border-r-0 md:border-r border-custom w-full md:w-8/12 lg:w-10/12 py-2 px-2 lg:px-5'>
            <h1 className='text-2xl font-bold pb-2'>
              Kekere Wallet
            </h1>
            <p className={'pb-6'}>You can top-up your wallet via bank transfer or a debit card; also you can set a low balance limit notification on your wallet</p>
            <div className="flex gap-6 flex-wrap lg:flex-nowrap">
              <div className="rounded-2xl bg-white w-full lg:w-6/12 p-4 flex flex-col gap-y-6">
                <div className={'flex justify-between'}>
                  <div className="flex justify-between w-full lg:gap-x-2.5 xl:gap-x-3.5 items-center">
                    <div className={'flex gap-3 items-center'}>
                      <Wallet3 color={'#727272'} size={18} variant="Bold" />
                      <p className={' text-custom'}>Available Balance</p>
                    </div>
                  </div>
                </div>
                {/*<p className='text-sm pt-5'>Balance</p>*/}
                {loading ? <WalletLoader /> :
                  <p
                    className=" font-bold text-2xl pt-3.5 pb-3">{formatCurrency(Number(walletInfo?.wallet_balance)) || 0}</p>}

                <div className={'flex gap-3 w-full lg:w-3/4'}>
                  <div
                    className={'border border-black w-[40%] rounded-2xl py-2 px-4  flex flex-col gap-y-1 items-center justify-center'}>
                    <p className={'text-xs text-custom font-light'}>{extractBankName(walletInfo?.account_number)}</p>
                    <div className={'flex gap-3 items-center'}>
                      {/* eslint-disable-next-line no-unsafe-optional-chaining */}
                      <p className={'lg:text-sm  text-xs'}>{extractAccountNumber(walletInfo?.account_number)}</p>
                      <span>
                        <Copy size="15" color="#727272" />
                      </span>
                    </div>
                  </div>
                  {/*<div*/}
                  {/*  className={'border border-black w-[50%] rounded-2xl py-2 px-5 flex gap-y-1 flex-col items-center'}>*/}
                  {/*  <GenerateAdd size={18} />*/}
                  {/*  <p className={'lg:text-xs text-xxs'}>Generate a Dedicated Account Number</p>*/}
                  {/*</div>*/}
                </div>


                {/*<div className='flex justify-between pb-4'>*/}
                {/*  <div>*/}
                {/*    <span className='text-xs'>Account Number</span>*/}
                {/*    {loading ? <WalletLoader/> : <p className='text-xs pt-1 font-semibold'>{walletInfo?.account_number}</p>}*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*  <span className='text-xs'>Account Name</span>*/}
                {/*    {loading ? <WalletLoader/> : <p className='text-xs pt-1 font-semibold'>{walletInfo?.account_name}</p>}*/}
                {/*  </div>*/}
                {/*</div>*/}
              </div>
              <div className="rounded-2xl bg-[#EEEEEE]  w-full lg:w-6/12 p-4 flex flex-col gap-y-8">
                <div className={'flex justify-between'}>
                  <div className="flex justify-between w-full lg:gap-x-2.5 xl:gap-x-3.5 items-center">
                    <div className={'flex gap-3 items-center'}>
                      <p className={'font-bold text-xl text-black'}>Wallet Guide</p>
                    </div>
                  </div>
                </div>

                <div className={'flex flex-col gap-2'}>
                  <p className={'font-bold'}>You can top-up your wallet via bank transfer.</p>
                  <p className={'lg:text-sm text-xs'}>
                    Transfer funds to our virtual account numbers to auto-credit your wallet. For issues, contact admin@kekere.com or your account rep.
                  </p>
                </div>


                {/*<div className='flex justify-between pb-4'>*/}
                {/*  <div>*/}
                {/*    <span className='text-xs'>Account Number</span>*/}
                {/*    {loading ? <WalletLoader/> : <p className='text-xs pt-1 font-semibold'>{walletInfo?.account_number}</p>}*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*  <span className='text-xs'>Account Name</span>*/}
                {/*    {loading ? <WalletLoader/> : <p className='text-xs pt-1 font-semibold'>{walletInfo?.account_name}</p>}*/}
                {/*  </div>*/}
                {/*</div>*/}
              </div>
            </div>
          </div>
        </div>
        <div className="py-5 px-5 md:px-10 ">
          <div className=" py-2 border border-custom rounded-custom bg-white">
            <div className={'flex justify-between items-center py-4 px-3.5'}>
              <h1 className="">
                Transaction History
              </h1>
              <div className={'flex gap-3'}>
                <button
                  className={'border border-custom-lemongreen flex gap-2 items-center rounded-lg text-xs lg:text-sm py-1 px-2 text-custom-green'}>
                  <Clock size="22" color="#20996B" />
                  Filter By Date
                </button>
                <button
                  className={'border border-custom-lemongreen flex gap-2 items-center rounded-lg text-xs lg:text-sm py-1 px-2 text-custom-green'}>
                  <Clock size="22" color="#20996B" />
                  Export
                </button>
              </div>
            </div>
            <table className="w-full">
              <thead className="font-semibold text-xs bg-custom-light-green uppercase">
              <tr className="">
                <th className="py-4">S/N</th>
                <th className={'md:table-cell hidden'}>Transaction id</th>
                <th>Transaction date</th>
                <th>amount paid</th>
                <th>payment type</th>
                <th>Action</th>
              </tr>
              </thead>


              {
                loading ? (
                    <tbody>
                    <tr>
                      <td colSpan={10} className="py-5 px-2">
                        <div className="flex flex-col justify-center items-center w-full py-16">
                          <Loader />
                        </div>
                      </td>
                    </tr>
                    </tbody>
                ) :
                  transactionHistory?.length !== 0 ?
                    <tbody>
                    {
                      transactionHistory?.map((historyData: User, index) =>
                        <tr key={index}
                            className="font-semibold text-xxs sm:text-xs text-center uppercase border-b-2 border-custom-light-green">
                          <td className="py-4">{historyData?.id}</td>
                          <td className={'md:table-cell hidden'}>{dateFormat(historyData?.created_at)}</td>
                          <td>{dateFormat(historyData?.created_at)}</td>
                          <td>{formatCurrency(historyData?.amount)}</td>
                          <td>{historyData?.type}</td>
                          <td>
                            <div className={'flex justify-center gap-4'}>
                              <Eye size="24" color="#000" variant="Bold" />
                            </div>
                          </td>
                        </tr>)
                    }
                    </tbody>
                    :
                    <tbody>
                    <tr>
                      <td colSpan={6} className="">
                        <div className="flex flex-col justify-center items-center w-full py-16">
                          <Cards size="64" color="#0F563B"/>
                          <p className='text-sm pt-1'>You have not made any Transaction Yet </p>
                        </div>
                      </td>
                    </tr>
                    </tbody>
              }

            </table>
          </div>
        </div>
        <FundwalletModal isOpen={isOpen.fundwallet} data={walletInfo} onHide={() => setIsOpen({ ...isOpen, fundwallet: false })}/>
        {/*<WithdrawalModal isOpen={isOpen.withdrawal} onHide={() => setIsOpen({ ...isOpen, withdrawal: false })} />*/}
      </div>
    </div>
  );
}

export default Wallet;
